import { render } from "./ReserveStepClients.vue?vue&type=template&id=9d64a10c&scoped=true"
import script from "./ReserveStepClients.vue?vue&type=script&lang=js"
export * from "./ReserveStepClients.vue?vue&type=script&lang=js"

import "./ReserveStepClients.vue?vue&type=style&index=0&id=9d64a10c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d64a10c"]])

export default __exports__